(function () {
  var configNode = document.getElementById("TrinelleKlaviyoConfig");
  if (!configNode) return;

  var config = {};
  try {
    config = JSON.parse(configNode.textContent || "{}");
  } catch (error) {
    console.error("Trinelle Klaviyo config parse failed", error);
    return;
  }

  var SCHEMA_VERSION = 2;
  var MAX_PASSIVE_QUEUE = 20;
  var PENDING_CART_CANDIDATE_KEY = "trinelle_pending_cart_candidate_v2";
  var PASSIVE_REPLAY_GUARD_KEY = "trinelle_recent_passive_events_v2";
  var RECENT_CART_CAPTURE_WINDOW_MS = 2500;
  var PASSIVE_REPLAY_WINDOW_MS = 3500;
  var endpoint = config.browserEventEndpoint;
  var emailCapture = config.emailCapture || {};
  var klaviyoCompanyId = String(emailCapture.klaviyoCompanyId || "").trim();
  var klaviyoListId = String(emailCapture.klaviyoListId || "").trim();
  var klaviyoRevision = String(emailCapture.revision || "2026-04-15").trim();
  var klaviyoEndpoint = String(emailCapture.klaviyoEndpoint || "https://a.klaviyo.com/client/subscriptions").trim();
  var klaviyoNativeSignupEnabled = emailCapture.mode === "klaviyo_native" && klaviyoCompanyId && klaviyoListId;
  var featureFlags = normalizeFeatureFlags(config.flags || {});
  var page = config.page || {};
  var CONSENT_QA_MATRIX = [
    {
      state: "no_consent",
      analyticsAllowed: false,
      marketingAllowed: false,
      viewed_product: "suppressed",
      added_to_cart: "suppressed",
      started_checkout: "suppressed",
      explicit_signup_submission: "allowed"
    },
    {
      state: "analytics_only",
      analyticsAllowed: true,
      marketingAllowed: false,
      viewed_product: "suppressed",
      added_to_cart: "suppressed",
      started_checkout: "suppressed",
      explicit_signup_submission: "allowed"
    },
    {
      state: "marketing_only",
      analyticsAllowed: false,
      marketingAllowed: true,
      viewed_product: "suppressed",
      added_to_cart: "suppressed",
      started_checkout: "suppressed",
      explicit_signup_submission: "allowed"
    },
    {
      state: "analytics_and_marketing",
      analyticsAllowed: true,
      marketingAllowed: true,
      viewed_product: "allowed",
      added_to_cart: "allowed",
      started_checkout: "allowed",
      explicit_signup_submission: "allowed"
    }
  ];
  var consentState = {
    ready: false,
    passiveAllowed: false,
    analyticsAllowed: false,
    marketingAllowed: false,
    reasonCode: "not_initialized",
    queueable: true,
    queue: []
  };
  var recentCartCaptures = {};
  var cartState = {
    itemCount: toNumber(page.lineItemCount),
    totalPrice: toNumber(page.cartTotalCents)
  };
  var debugEnabled = isDebugEnabled(featureFlags.storefrontDebugLoggingEnabled);
  var qaState = {
    passiveDecisions: []
  };

  if (!endpoint && !klaviyoNativeSignupEnabled) {
    console.warn("Trinelle email capture is missing a middleware endpoint or Klaviyo native signup settings.");
    return;
  }

  if (!endpoint) {
    console.warn("Trinelle passive browser event endpoint is missing; passive tracking is disabled.");
  }

  function normalizeFeatureFlags(source) {
    return {
      passiveTrackingEnabled: source.passiveTrackingEnabled !== false,
      addToCartFallbackEnabled: source.addToCartFallbackEnabled !== false,
      storefrontDebugLoggingEnabled: source.storefrontDebugLoggingEnabled === true
    };
  }

  function isDebugEnabled(flagEnabled) {
    try {
      var params = new URLSearchParams(window.location.search);
      if (params.get("trinelle_klaviyo_debug") === "1") return true;
      if (flagEnabled) return true;
      return window.localStorage.getItem("trinelle_klaviyo_debug") === "1";
    } catch (error) {
      return Boolean(flagEnabled);
    }
  }

  function debugLog(message, details) {
    if (!debugEnabled || !window.console || typeof window.console.info !== "function") return;
    if (details) {
      window.console.info("[Trinelle Klaviyo]", message, details);
      return;
    }

    window.console.info("[Trinelle Klaviyo]", message);
  }

  function toNumber(value) {
    var numeric = Number(value);
    return isFinite(numeric) ? numeric : 0;
  }

  function getConsentSnapshot(reasonCode) {
    var visitorConsent = getVisitorConsent();
    return {
      ready: consentState.ready,
      passiveTrackingEnabled: featureFlags.passiveTrackingEnabled,
      passiveAllowed: consentState.passiveAllowed,
      analyticsAllowed: consentState.analyticsAllowed,
      marketingAllowed: consentState.marketingAllowed,
      queueable: consentState.queueable,
      reasonCode: reasonCode || consentState.reasonCode,
      visitorConsentState: visitorConsent
        ? {
            analytics: visitorConsent.analytics,
            marketing: visitorConsent.marketing,
            preferences: visitorConsent.preferences,
            sale_of_data: visitorConsent.sale_of_data
          }
        : null
    };
  }

  function debugPassiveDecision(eventName, action, reasonCode, extraDetails) {
    var decision = Object.assign({
      event_name: eventName,
      reason_code: reasonCode
    }, getConsentSnapshot(reasonCode), extraDetails || {});
    rememberQaDecision(action, decision);
    debugLog("Passive event " + action, decision);
  }

  function rememberQaDecision(action, decision) {
    qaState.passiveDecisions.push({
      action: action,
      decision: Object.assign({}, decision),
      observed_at: getCurrentTimestamp()
    });

    if (qaState.passiveDecisions.length > 20) {
      qaState.passiveDecisions.shift();
    }
  }

  function getConsentQaMatrix() {
    return CONSENT_QA_MATRIX.map(function (entry) {
      return Object.assign({}, entry);
    });
  }

  function getLaunchStatus() {
    return {
      endpointConfigured: Boolean(endpoint),
      signupConfigured: Boolean(endpoint || klaviyoNativeSignupEnabled),
      signupMode: klaviyoNativeSignupEnabled ? "klaviyo_native" : (endpoint ? "middleware" : "disabled"),
      pageType: page.pageType || "",
      debugEnabled: debugEnabled,
      flags: Object.assign({}, featureFlags),
      consent: getConsentSnapshot(),
      recentPassiveDecisions: qaState.passiveDecisions.slice()
    };
  }

  function exposeQaHelper() {
    if (!debugEnabled) {
      try {
        delete window.__trinelleKlaviyoQA;
      } catch (error) {
      }
      return;
    }

    window.__trinelleKlaviyoQA = {
      getConsentSnapshot: function () {
        return getConsentSnapshot();
      },
      getConsentMatrix: function () {
        return getConsentQaMatrix();
      },
      getLaunchStatus: function () {
        return getLaunchStatus();
      },
      getRecentPassiveDecisions: function () {
        return qaState.passiveDecisions.slice();
      },
      logConsentMatrix: function () {
        if (window.console && typeof window.console.table === "function") {
          window.console.table(getConsentQaMatrix());
          return;
        }

        debugLog("Consent QA matrix", {
          matrix: getConsentQaMatrix()
        });
      },
      logLaunchStatus: function () {
        debugLog("Launch QA status", getLaunchStatus());
      }
    };
  }

  function getUtmParameters() {
    var params = new URLSearchParams(window.location.search);
    return {
      utm_source: params.get("utm_source") || "",
      utm_medium: params.get("utm_medium") || "",
      utm_campaign: params.get("utm_campaign") || ""
    };
  }

  function getCurrentTimestamp() {
    return new Date().toISOString();
  }

  function getPageUrl() {
    if (window.location && window.location.href) return window.location.href;
    return (window.location.origin || "") + (page.path || window.location.pathname || "");
  }

  function getSafeReferrer() {
    if (!document.referrer) return "";

    try {
      var url = new URL(document.referrer);
      return url.origin + url.pathname;
    } catch (error) {
      return "";
    }
  }

  function buildPageContext() {
    return {
      path: page.path || window.location.pathname || "",
      productHandle: page.productHandle || "",
      productId: page.productId || "",
      variantId: page.variantId || "",
      productTitle: page.productTitle || "",
      currency: page.currency || "",
      cartToken: page.cartToken || "",
      cartTotalCents: cartState.totalPrice,
      lineItemCount: cartState.itemCount
    };
  }

  function buildEventEnvelope(eventName, payload, eventIdOverride) {
    var sentAt = getCurrentTimestamp();

    return Object.assign(
      {
        schema_version: SCHEMA_VERSION,
        event_name: eventName,
        event_id: eventIdOverride || generateEventId(),
        sent_at: sentAt,
        occurred_at: sentAt,
        source_system: "shopify",
        anonymous_id: readStorage(window.localStorage, "trinelle_anonymous_id"),
        session_id: readStorage(window.sessionStorage, "trinelle_session_id"),
        customer_id: page.customerId || "",
        page_path: page.path || window.location.pathname,
        page_url: getPageUrl(),
        referrer: getSafeReferrer(),
        currency_code: page.currency || "",
        origin: window.location.origin || ""
      },
      getUtmParameters(),
      payload || {}
    );
  }

  function postEnvelope(envelope) {
    if (!endpoint) {
      return Promise.reject(new Error("passive browser event endpoint missing"));
    }

    return fetch(endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify(envelope),
      credentials: "omit",
      keepalive: true
    });
  }

  function getVisitorConsent() {
    if (!window.Shopify || !window.Shopify.customerPrivacy || typeof window.Shopify.customerPrivacy.currentVisitorConsent !== "function") {
      return null;
    }

    try {
      return window.Shopify.customerPrivacy.currentVisitorConsent();
    } catch (error) {
      debugLog("Customer Privacy API currentVisitorConsent failed", {
        message: error && error.message ? error.message : String(error)
      });
      return null;
    }
  }

  function isPassiveConsentPending() {
    var consent = getVisitorConsent();
    if (!consent) return false;

    return consent.analytics === "" || consent.marketing === "";
  }

  function evaluatePassiveTrackingAllowed() {
    if (!window.Shopify || !window.Shopify.customerPrivacy) {
      consentState.analyticsAllowed = false;
      consentState.marketingAllowed = false;
      consentState.reasonCode = "privacy_api_unavailable";
      return false;
    }

    try {
      consentState.analyticsAllowed = Boolean(window.Shopify.customerPrivacy.analyticsProcessingAllowed());
      consentState.marketingAllowed = Boolean(window.Shopify.customerPrivacy.marketingAllowed());
      if (consentState.analyticsAllowed && consentState.marketingAllowed) {
        consentState.reasonCode = "consent_granted";
      } else if (consentState.analyticsAllowed) {
        consentState.reasonCode = "marketing_consent_missing";
      } else if (consentState.marketingAllowed) {
        consentState.reasonCode = "analytics_consent_missing";
      } else {
        consentState.reasonCode = "consent_denied";
      }

      return Boolean(consentState.analyticsAllowed && consentState.marketingAllowed);
    } catch (error) {
      consentState.analyticsAllowed = false;
      consentState.marketingAllowed = false;
      consentState.reasonCode = "privacy_api_error";
      debugLog("Customer Privacy API allowed-check failed", {
        message: error && error.message ? error.message : String(error)
      });
      return false;
    }
  }

  function flushPassiveQueue() {
    if (!consentState.ready || !consentState.passiveAllowed || !consentState.queue.length) return;

    var queuedEnvelopes = consentState.queue.slice();
    consentState.queue = [];

    queuedEnvelopes.forEach(function (entry) {
      if (entry.replaySignature) markRecentPassiveReplay(entry.replaySignature);
      debugPassiveDecision(entry.envelope.event_name, "allowed", "consent_granted_from_queue", {
        replay_signature: entry.replaySignature || ""
      });
      postEnvelope(entry.envelope).catch(function (error) {
        console.error("Trinelle Klaviyo queued passive event failed", error);
      });
    });
  }

  function updateConsentState(source) {
    consentState.ready = true;
    consentState.passiveAllowed = evaluatePassiveTrackingAllowed();
    debugLog("Passive tracking consent updated", Object.assign({
      source: source
    }, getConsentSnapshot()));
    flushPassiveQueue();
  }

  function queuePassiveEnvelope(envelope, replaySignature) {
    if (consentState.queue.length >= MAX_PASSIVE_QUEUE) {
      consentState.queue.shift();
    }

    consentState.queue.push({
      envelope: envelope,
      replaySignature: replaySignature || ""
    });
    debugPassiveDecision(envelope.event_name, "queued", consentState.reasonCode || "consent_pending", {
      replay_signature: replaySignature || ""
    });
  }

  function readRecentPassiveReplays() {
    var stored = readStorage(window.sessionStorage, PASSIVE_REPLAY_GUARD_KEY);
    if (!stored) return {};

    try {
      var parsed = JSON.parse(stored);
      return parsed && typeof parsed === "object" ? parsed : {};
    } catch (error) {
      removeStorage(window.sessionStorage, PASSIVE_REPLAY_GUARD_KEY);
      return {};
    }
  }

  function writeRecentPassiveReplays(map) {
    writeStorage(window.sessionStorage, PASSIVE_REPLAY_GUARD_KEY, JSON.stringify(map));
  }

  function pruneRecentPassiveReplays() {
    var cutoff = Date.now() - PASSIVE_REPLAY_WINDOW_MS;
    var recentReplays = readRecentPassiveReplays();
    var changed = false;

    Object.keys(recentReplays).forEach(function (signature) {
      if (toNumber(recentReplays[signature]) < cutoff) {
        delete recentReplays[signature];
        changed = true;
      }
    });

    if (changed) writeRecentPassiveReplays(recentReplays);
    return recentReplays;
  }

  function hasRecentPassiveReplay(signature) {
    var recentReplays = pruneRecentPassiveReplays();
    return Boolean(recentReplays[signature]);
  }

  function markRecentPassiveReplay(signature) {
    var recentReplays = pruneRecentPassiveReplays();
    recentReplays[signature] = Date.now();
    writeRecentPassiveReplays(recentReplays);
  }

  function buildPassiveReplaySignature(eventName, payload) {
    if (eventName === "added_to_cart") {
      return [
        eventName,
        String(payload.variant_id || ""),
        String(payload.product_handle || ""),
        String(payload.cart_id || ""),
        String(payload.properties && payload.properties.quantity || 1)
      ].join("|");
    }

    if (eventName === "started_checkout") {
      return [
        eventName,
        String(payload.cart_id || ""),
        String(payload.checkout_token || ""),
        String(payload.properties && payload.properties.line_item_count || 0),
        String(payload.properties && payload.properties.cart_value || 0)
      ].join("|");
    }

    return "";
  }

  function sendPassiveEvent(eventName, payload, eventIdOverride, options) {
    var sendOptions = options || {};
    var envelope = buildEventEnvelope(eventName, payload, eventIdOverride);
    var replaySignature = sendOptions.replaySignature || buildPassiveReplaySignature(eventName, envelope);

    if (!endpoint) {
      debugPassiveDecision(eventName, "suppressed", "passive_endpoint_missing");
      return Promise.resolve(null);
    }

    if (!featureFlags.passiveTrackingEnabled) {
      debugPassiveDecision(eventName, "suppressed", "passive_tracking_disabled");
      return Promise.resolve(null);
    }

    if (replaySignature && hasRecentPassiveReplay(replaySignature)) {
      debugPassiveDecision(eventName, "suppressed", "replay_guard_duplicate", {
        replay_signature: replaySignature
      });
      return Promise.resolve(null);
    }

    if (!consentState.ready) {
      consentState.reasonCode = "consent_pending";
      queuePassiveEnvelope(envelope, replaySignature);
      return Promise.resolve(null);
    }

    if (consentState.passiveAllowed) {
      if (replaySignature) markRecentPassiveReplay(replaySignature);
      debugPassiveDecision(eventName, "allowed", "consent_granted", {
        replay_signature: replaySignature || ""
      });
      return postEnvelope(envelope);
    }

    if (consentState.queueable && isPassiveConsentPending()) {
      consentState.reasonCode = "consent_pending";
      queuePassiveEnvelope(envelope, replaySignature);
      return Promise.resolve(null);
    }

    debugPassiveDecision(envelope.event_name, "suppressed", consentState.reasonCode || "consent_denied", {
      replay_signature: replaySignature || ""
    });
    return Promise.resolve(null);
  }

  function initCustomerPrivacy() {
    if (window.Shopify && window.Shopify.customerPrivacy) {
      updateConsentState("preloaded");
    } else if (window.Shopify && typeof window.Shopify.loadFeatures === "function") {
      window.Shopify.loadFeatures(
        [
          {
            name: "consent-tracking-api",
            version: "0.1"
          }
        ],
        function (error) {
          if (error) {
            consentState.ready = true;
            consentState.passiveAllowed = false;
            consentState.analyticsAllowed = false;
            consentState.marketingAllowed = false;
            consentState.reasonCode = "privacy_api_load_failed";
            consentState.queueable = false;
            debugLog("Customer Privacy API load failed", {
              message: error && error.message ? error.message : String(error)
            });
            return;
          }

          updateConsentState("loaded");
        }
      );
    } else {
      consentState.ready = true;
      consentState.passiveAllowed = false;
      consentState.analyticsAllowed = false;
      consentState.marketingAllowed = false;
      consentState.reasonCode = "privacy_api_unavailable";
      consentState.queueable = false;
      debugLog("Customer Privacy API unavailable; passive tracking suppressed");
    }

    document.addEventListener("visitorConsentCollected", function () {
      updateConsentState("visitorConsentCollected");
    });
  }

  function readStorage(storage, key) {
    try {
      return storage.getItem(key) || "";
    } catch (error) {
      return "";
    }
  }

  function writeStorage(storage, key, value) {
    try {
      storage.setItem(key, value);
    } catch (error) {
      debugLog("Storage write failed", { key: key });
    }
  }

  function removeStorage(storage, key) {
    try {
      storage.removeItem(key);
    } catch (error) {
      debugLog("Storage remove failed", { key: key });
    }
  }

  function ensureSessionId() {
    var existing = readStorage(window.sessionStorage, "trinelle_session_id");
    if (existing) return existing;

    var generated = "sess_" + Math.random().toString(36).slice(2) + Date.now().toString(36);
    writeStorage(window.sessionStorage, "trinelle_session_id", generated);
    return generated;
  }

  function ensureAnonymousId() {
    var existing = readStorage(window.localStorage, "trinelle_anonymous_id");
    if (existing) return existing;

    var generated = "anon_" + Math.random().toString(36).slice(2) + Date.now().toString(36);
    writeStorage(window.localStorage, "trinelle_anonymous_id", generated);
    return generated;
  }

  function setFormValue(form, fieldName, fieldValue) {
    var field = form.querySelector('input[name="' + fieldName + '"]');
    if (!field) return;
    field.value = fieldValue;
  }

  function hydrateSubmissionInputs(form) {
    var eventIdInput = form.querySelector('input[name="event_id"]');
    var anonymousIdInput = form.querySelector('input[name="anonymous_id"]');
    var sessionIdInput = form.querySelector('input[name="session_id"]');

    if (eventIdInput && !eventIdInput.value) eventIdInput.value = generateEventId();
    if (anonymousIdInput) anonymousIdInput.value = ensureAnonymousId();
    if (sessionIdInput) sessionIdInput.value = ensureSessionId();

    setFormValue(form, "schema_version", String(SCHEMA_VERSION));
    setFormValue(form, "sent_at", getCurrentTimestamp());
    setFormValue(form, "page_url", getPageUrl());
    setFormValue(form, "referrer", getSafeReferrer());
  }

  function generateEventId() {
    if (window.crypto && typeof window.crypto.randomUUID === "function") {
      return window.crypto.randomUUID();
    }

    return "00000000-0000-4000-8000-" + Math.random().toString(16).slice(2, 14).padEnd(12, "0");
  }

  function trackViewedProduct() {
    if (page.pageType !== "product" || !page.productHandle) return;
    if (!featureFlags.passiveTrackingEnabled) {
      debugPassiveDecision("viewed_product", "suppressed", "passive_tracking_disabled");
      return;
    }

    var storageKey = "trinelle_viewed_product_" + page.productHandle;
    if (readStorage(window.sessionStorage, storageKey)) return;

    writeStorage(window.sessionStorage, storageKey, "1");
    sendPassiveEvent("viewed_product", {
      product_handle: page.productHandle,
      product_id: page.productId || "",
      variant_id: page.variantId || "",
      currency_code: page.currency || "",
      properties: {
        product_title: page.productTitle || "",
        collection_handle: page.collectionHandle || "",
        currency: page.currency || "",
        consent_scope: "analytics_and_marketing",
        tracking_mode: "passive"
      }
    }).catch(function (error) {
      console.error("Trinelle Klaviyo viewed_product failed", error);
    });
  }

  function bindSignupForms() {
    document.querySelectorAll("[data-trinelle-signup-form]").forEach(function (form) {
      hydrateSubmissionInputs(form);
      form.addEventListener("submit", function (event) {
        event.preventDefault();

        var email = form.querySelector('input[name="email"]');
        var leadMagnet = form.querySelector('select[name="lead_magnet"]');
        var consent = form.querySelector('input[name="consent"]');
        var honeypot = form.querySelector('input[name="company_name"]');
        var feedback = form.querySelector("[data-trinelle-signup-feedback]");
        hydrateSubmissionInputs(form);
        var formData = new FormData(form);

        if (honeypot && honeypot.value) return;
        if (!email || !leadMagnet || !consent || !consent.checked) return;

        var submission = klaviyoNativeSignupEnabled
          ? postKlaviyoNativeSubscription(form, formData)
          : postMiddlewareSignup(form, formData);

        submission.then(function () {
          if (feedback) {
            feedback.textContent = feedback.dataset.successMessage || feedback.textContent;
            feedback.hidden = false;
          }
          form.reset();
          hydrateSubmissionInputs(form);
        }).catch(function (error) {
          console.error("Trinelle Klaviyo signup failed", error);
          if (feedback) {
            feedback.textContent = "We could not complete the signup. Please try again in a moment.";
            feedback.hidden = false;
          }
          if (!klaviyoNativeSignupEnabled) {
            HTMLFormElement.prototype.submit.call(form);
          }
        });
      });
    });
  }

  function postMiddlewareSignup(form, formData) {
    return fetch(form.action, {
          method: "POST",
          body: formData,
          credentials: "omit",
          headers: {
            "Accept": "application/json",
            "X-Trinelle-Submission-Mode": "enhanced"
          }
        }).then(assertSuccessfulSignupResponse);
  }

  function postKlaviyoNativeSubscription(form, formData) {
    return fetch(resolveKlaviyoSubscriptionEndpoint(), {
      method: "POST",
      credentials: "omit",
      headers: {
        "Content-Type": "application/vnd.api+json",
        "Accept": "application/vnd.api+json",
        "revision": klaviyoRevision
      },
      body: JSON.stringify(buildKlaviyoSubscriptionPayload(form, formData))
    }).then(assertSuccessfulSignupResponse);
  }

  function assertSuccessfulSignupResponse(response) {
    if (!response.ok) {
      throw new Error("signup request failed with status " + response.status);
    }

    return response;
  }

  function resolveKlaviyoSubscriptionEndpoint() {
    var url = new URL(klaviyoEndpoint, window.location.origin);
    url.searchParams.set("company_id", klaviyoCompanyId);
    return url.toString();
  }

  function buildKlaviyoSubscriptionPayload(form, formData) {
    var submittedAt = getCurrentTimestamp();
    var properties = {
      event_name: String(formData.get("event_name") || "email_signup"),
      lead_magnet: String(formData.get("lead_magnet") || ""),
      form_name: String(formData.get("form_name") || form.dataset.formIdentifier || "skin-literacy-signup"),
      capture_source: String(formData.get("capture_source") || form.dataset.captureSource || "skin-literacy"),
      brand_touchpoint: String(formData.get("brand_touchpoint") || "shopify_signup_section"),
      page_path: String(formData.get("page_path") || page.path || window.location.pathname || ""),
      page_url: String(formData.get("page_url") || getPageUrl()),
      page_title: String(formData.get("page_title") || document.title || ""),
      submitted_at: submittedAt,
      source_system: "shopify_qa_theme",
      signup_path: "klaviyo_native_client_subscription",
      schema_version: String(SCHEMA_VERSION)
    };

    return {
      data: {
        type: "subscription",
        attributes: {
          custom_source: properties.capture_source,
          profile: {
            data: {
              type: "profile",
              attributes: {
                email: String(formData.get("email") || "").trim(),
                properties: properties,
                subscriptions: {
                  email: {
                    marketing: {
                      consent: "SUBSCRIBED"
                    }
                  }
                }
              }
            }
          }
        },
        relationships: {
          list: {
            data: {
              type: "list",
              id: klaviyoListId
            }
          }
        }
      }
    };
  }

  function parseCartAddRequestBody(body) {
    if (!body) return {};

    if (body instanceof FormData) {
      return {
        quantity: toNumber(body.get("quantity") || 1),
        variantId: String(body.get("id") || "")
      };
    }

    if (typeof body === "string") {
      var params = new URLSearchParams(body);
      return {
        quantity: toNumber(params.get("quantity") || 1),
        variantId: params.get("id") || ""
      };
    }

    if (body instanceof URLSearchParams) {
      return {
        quantity: toNumber(body.get("quantity") || 1),
        variantId: body.get("id") || ""
      };
    }

    if (typeof body === "object") {
      return {
        quantity: toNumber(body.quantity || 1),
        variantId: String(body.variantId || "")
      };
    }

    return {};
  }

  function buildCartSignature(requestData, pageContext) {
    return [
      String(requestData.variantId || pageContext.variantId || ""),
      String(requestData.quantity || 1),
      String(pageContext.productHandle || ""),
      String(pageContext.path || "")
    ].join("|");
  }

  function pruneRecentCartCaptures() {
    var cutoff = Date.now() - RECENT_CART_CAPTURE_WINDOW_MS;
    Object.keys(recentCartCaptures).forEach(function (signature) {
      if (recentCartCaptures[signature] < cutoff) {
        delete recentCartCaptures[signature];
      }
    });
  }

  function hasRecentCartCapture(signature) {
    pruneRecentCartCaptures();
    return Boolean(recentCartCaptures[signature]);
  }

  function markRecentCartCapture(signature, capturePath) {
    recentCartCaptures[signature] = Date.now();
    debugLog("Add-to-cart capture path fired", {
      path: capturePath,
      signature: signature
    });
  }

  function updateCartState(cart) {
    if (!cart) return;

    cartState.itemCount = toNumber(cart.item_count);
    cartState.totalPrice = toNumber(cart.total_price);
  }

  function didCartStateChange(cart, baselineCart) {
    if (!cart) return false;

    return toNumber(cart.item_count) !== toNumber(baselineCart.itemCount)
      || toNumber(cart.total_price) !== toNumber(baselineCart.totalPrice);
  }

  function fetchCartState() {
    return fetch("/cart.js", { credentials: "same-origin" }).then(function (response) {
      return response.ok ? response.json() : null;
    });
  }

  function clearPendingCartCandidate(signature) {
    var stored = readStorage(window.sessionStorage, PENDING_CART_CANDIDATE_KEY);
    if (!stored) return;

    try {
      var candidate = JSON.parse(stored);
      if (!signature || candidate.signature === signature) {
        removeStorage(window.sessionStorage, PENDING_CART_CANDIDATE_KEY);
      }
    } catch (error) {
      removeStorage(window.sessionStorage, PENDING_CART_CANDIDATE_KEY);
    }
  }

  function storePendingCartCandidate(requestData, baselineCart, pageContext) {
    var signature = buildCartSignature(requestData, pageContext);
    var payload = {
      createdAt: Date.now(),
      baselineCart: baselineCart,
      pageContext: pageContext,
      requestData: requestData,
      signature: signature
    };

    writeStorage(window.sessionStorage, PENDING_CART_CANDIDATE_KEY, JSON.stringify(payload));
    return signature;
  }

  function replayPendingCartCandidate() {
    if (!featureFlags.addToCartFallbackEnabled) {
      removeStorage(window.sessionStorage, PENDING_CART_CANDIDATE_KEY);
      return;
    }

    var stored = readStorage(window.sessionStorage, PENDING_CART_CANDIDATE_KEY);
    if (!stored) return;

    var candidate = null;
    try {
      candidate = JSON.parse(stored);
    } catch (error) {
      removeStorage(window.sessionStorage, PENDING_CART_CANDIDATE_KEY);
      return;
    }

    if (!candidate || !candidate.createdAt || Date.now() - candidate.createdAt > 5000) {
      removeStorage(window.sessionStorage, PENDING_CART_CANDIDATE_KEY);
      return;
    }

    emitSuccessfulAddToCart(
      candidate.requestData,
      null,
      "form_submit_replay",
      candidate.baselineCart,
      candidate.pageContext
    ).finally(function () {
      clearPendingCartCandidate(candidate.signature);
    });
  }

  function emitSuccessfulAddToCart(requestData, responseData, capturePath, baselineCart, pageContext) {
    var resolvedPage = pageContext || buildPageContext();
    var resolvedRequest = parseCartAddRequestBody(requestData);
    var signature = buildCartSignature(resolvedRequest, resolvedPage);

    if (hasRecentCartCapture(signature)) {
      clearPendingCartCandidate(signature);
      return Promise.resolve(null);
    }

    return fetchCartState()
      .then(function (cart) {
        if (baselineCart && !didCartStateChange(cart, baselineCart)) {
          debugLog("Skipped add-to-cart fallback because cart state did not change", {
            path: capturePath,
            signature: signature
          });
          return null;
        }

        markRecentCartCapture(signature, capturePath);
        clearPendingCartCandidate(signature);
        updateCartState(cart);

        return sendPassiveEvent("added_to_cart", {
          cart_id: (cart && cart.token) || resolvedPage.cartToken || "",
          product_handle: resolvedPage.productHandle || "",
          product_id: (responseData && responseData.product_id) || resolvedPage.productId || "",
          variant_id: resolvedRequest.variantId || (responseData && responseData.variant_id) || resolvedPage.variantId || "",
          currency_code: resolvedPage.currency || "",
          properties: {
            quantity: resolvedRequest.quantity || toNumber((responseData && responseData.quantity) || 1),
            product_title: (responseData && (responseData.product_title || responseData.title)) || resolvedPage.productTitle || "",
            cart_value: (cart && cart.total_price) || resolvedPage.cartTotalCents || 0,
            line_item_count: (cart && cart.item_count) || resolvedPage.lineItemCount || 0,
            currency: resolvedPage.currency || "",
            capture_path: capturePath,
            consent_scope: "analytics_and_marketing",
            tracking_mode: "passive"
          }
        }, null, {
          replaySignature: "added_to_cart|" + signature
        });
      })
      .catch(function (error) {
        console.error("Trinelle Klaviyo add_to_cart failed", error);
      });
  }

  function bindAddToCartFetchInterceptor() {
    if (typeof window.fetch !== "function") return;
    if (window.__trinelleKlaviyoFetchBound) return;

    var originalFetch = window.fetch.bind(window);
    window.__trinelleKlaviyoFetchBound = true;
    window.fetch = function (input, init) {
      var requestUrl = typeof input === "string" ? input : input && input.url ? input.url : "";
      var requestMethod = init && init.method
        ? String(init.method).toUpperCase()
        : (typeof input === "object" && input && "method" in input && input.method ? String(input.method).toUpperCase() : "GET");
      var isCartAdd = requestMethod === "POST" && /\/cart\/add(\.js)?(\?|$)/.test(requestUrl);
      var requestData = parseCartAddRequestBody(init && init.body);
      var baselineCart = {
        itemCount: cartState.itemCount,
        totalPrice: cartState.totalPrice
      };

      return originalFetch(input, init).then(function (response) {
        if (isCartAdd && response.ok) {
          response.clone().json().then(function (responseData) {
            emitSuccessfulAddToCart(requestData, responseData, "fetch_intercept", baselineCart, buildPageContext());
          }).catch(function (error) {
            console.error("Trinelle cart response parse failed", error);
          });
        }

        return response;
      });
    };
  }

  function isAddToCartForm(form) {
    if (!form || form.tagName !== "FORM") return false;

    var action = form.getAttribute("action") || form.action || "";
    if (/\/cart\/add(\.js)?(\?|$)/.test(action)) return true;

    return Boolean(
      form.querySelector('input[name="id"]')
      && form.querySelector('button[type="submit"], input[type="submit"], [name="add"]')
    );
  }

  function bindAddToCartFormFallback() {
    if (!featureFlags.addToCartFallbackEnabled) {
      debugLog("Add-to-cart fallback disabled by feature flag");
      return;
    }

    document.addEventListener(
      "submit",
      function (event) {
        var form = event.target;
        if (!isAddToCartForm(form)) return;

        var requestData = parseCartAddRequestBody(new FormData(form));
        var baselineCart = {
          itemCount: cartState.itemCount,
          totalPrice: cartState.totalPrice
        };
        var pageContext = buildPageContext();
        var signature = storePendingCartCandidate(requestData, baselineCart, pageContext);

        debugLog("Registered add-to-cart fallback candidate", {
          signature: signature
        });

        window.setTimeout(function () {
          if (hasRecentCartCapture(signature)) {
            clearPendingCartCandidate(signature);
            return;
          }

          emitSuccessfulAddToCart(requestData, null, "form_submit_fallback", baselineCart, pageContext);
        }, 1200);
      },
      true
    );
  }

  function bindCheckoutStart() {
    document.querySelectorAll('form[action*="/cart"]').forEach(function (form) {
      form.addEventListener("submit", function (event) {
        var submitter = event.submitter;
        if (!submitter || submitter.name !== "checkout") return;

        sendPassiveEvent("started_checkout", {
          cart_id: page.cartToken || "",
          currency_code: page.currency || "",
          properties: {
            cart_value: cartState.totalPrice || 0,
            line_item_count: cartState.itemCount || 0,
            currency: page.currency || "",
            observation_mode: "cart_checkout_submit",
            consent_scope: "analytics_and_marketing",
            tracking_mode: "passive"
          }
        }, null, {
          replaySignature: [
            "started_checkout",
            String(page.cartToken || ""),
            String(cartState.itemCount || 0),
            String(cartState.totalPrice || 0)
          ].join("|")
        }).catch(function (error) {
          console.error("Trinelle Klaviyo checkout start failed", error);
        });
      });
    });
  }

  ensureSessionId();
  ensureAnonymousId();
  exposeQaHelper();
  debugLog("Initialized Trinelle Klaviyo storefront config", {
    passiveTrackingEnabled: featureFlags.passiveTrackingEnabled,
    addToCartFallbackEnabled: featureFlags.addToCartFallbackEnabled,
    storefrontDebugLoggingEnabled: featureFlags.storefrontDebugLoggingEnabled,
    qaHelperAvailable: debugEnabled
  });
  if (debugEnabled) {
    debugLog("Consent QA helper available", {
      helper: "__trinelleKlaviyoQA"
    });
  }
  if (endpoint) {
    initCustomerPrivacy();
    replayPendingCartCandidate();
    trackViewedProduct();
  }
  bindSignupForms();
  if (endpoint) {
    bindAddToCartFetchInterceptor();
    bindAddToCartFormFallback();
    bindCheckoutStart();
  }
})();
